var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{model:{value:(_vm.aggregateFunction),callback:function ($$v) {_vm.aggregateFunction=$$v},expression:"aggregateFunction"}},_vm._l((_vm.aggregateFunctions),function(fn){return _c('b-form-select-option',{attrs:{"value":fn.name}},[_vm._v(" "+_vm._s(fn.display || `${fn.name}()`)+" - "+_vm._s(fn.description)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }